<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 150px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/inventory')") Inventory
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/services')") Services
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/packages')") Packages
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/stocktakes')") Stock take
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="company.is_hq || company.branch_of" @click="$router.push('/admin/clinic/branches-warehouses')") Branches & Warehouses
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/locations')") Locations
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 List

    v-col.grow
      v-container.py-8(fluid)
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="neutral700" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text List

        v-row.pb-2.pb-md-0(no-gutters)
          v-col(cols="12" md="7")
            v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold" @change="tabChanged(tabs)")
              v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
        
          v-col(cols="12" md="5" align="end")
            .d-flex.align-center
              v-spacer
              v-btn(@click="clickSearch" icon color="neutral500")
                v-icon(size="20") $yzi-search-sm
              v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat :placeholder="$t('type_to_search')" hide-details clearable autofocus)
              div
                customize-column-menu(type="all_inventory_list" :showTooltip="false" iconSize="21")
              v-btn.button-sm.ml-4(color="neutral700" dark depressed @click="addNew") Add new
        v-divider
        //- Filters
        inventory-list-filter-row.mt-4(:filters.sync="filters" ref="filter")
        //- Table
        .data-table
          v-data-table.mt-sm-4.pb-6(:headers="headers" :items="inventoryList" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="handleEditList")
            //- created
            template(v-slot:item.created="{ item }")
              .text-sm.neutral700--text {{ displayDate(item.created) }}
            //- actions
            template(v-slot:item.actions="{ item, index }")
              div.d-flex(@click.stop)
                v-spacer
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    v-list-item(@click="handleEditList(item)")
                      v-list-item-title.text-sm.basic800--text Edit
                    v-divider
                    v-list-item(@click="handleDeleteList(item)")
                      v-list-item-title.text-sm.danger500--text Delete

        div.d-flex.align-center(v-if="totalCount > pageSize")
          v-spacer
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")
  .dialogs
    add-edit-list-dialog(v-if="openAddEditList" :open.sync="openAddEditList" :parentId="selectedListId" @updated="fetchInventoryLists" @close="selectedList = null")
    delete-list-confirmation-dialog(v-if="openDeleteListConfirmationDialog" :open.sync="openDeleteListConfirmationDialog" :parentData="selectedList" @deleted="fetchInventoryLists")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import { DateTime } from 'luxon'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteServiceDialog from '@/components/clinic/dialogs/DeleteServiceDialog.vue'
import AddEditListDialog from '@/components/clinic/dialogs/purchasehub/AddEditListDialog.vue'
import DeleteListConfirmationDialog from '@/components/clinic/dialogs/purchasehub/DeleteListConfirmationDialog.vue'
import InventoryListFilterRow from '@/components/clinic/purchasehub/filters/InventoryListFilterRow.vue'

export default {
  components: { CustomizeColumnMenu, DeleteServiceDialog, AddEditListDialog, DeleteListConfirmationDialog, InventoryListFilterRow },
  props: ['prevPage', 'prevTab'],
  data: () => ({
    isFetching: false,
    searchText: '',
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    inventoryList: [],
    tabs: 0,
    selectedList: null,
    showSearchField: false,
    openDeleteListConfirmationDialog: false,
    filters: [],
    openAddEditList: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
      inventoryListFields: 'clinic/getInventoryListFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const fields = this.inventoryListFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false
      }
      return [...fields, actions]
    },
    selectedListId () {
      return this.selectedList ? this.selectedList.id : null
    },
  },
  watch: {
    filters () {
      this.currentPage = 1
      this.fetchInventoryLists()
    },
  },
  mounted () {
    if (this.prevPage) {
      this.currentPage = this.prevPage
    }
    if (this.prevTab) {
      this.tabs = this.prevTab
    }
    this.headers.map(item => item['class'] = 'text-table-header')
    this.fetchInventoryLists()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchInventoryLists () {
      this.isFetching = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage,
      }
      if (this.searchText) { params.search = this.searchText }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      this.$axios.get(`/clinics/${this.company.slug}/inventory_lists`, { params })
        .then(resp => {
          this.inventoryList = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchInventoryLists()
    }, 750),
    pageChanged () {
      this.fetchInventoryLists()
    },
    tabChanged () {
      this.searchText = null
      this.currentPage = 1
      this.$refs.filter.resetFilters()
      // this.fetchInventoryLists()
    },
    addNew () {
      this.openAddEditList = true
    },
    handleEditList (item) {
      this.selectedList = item
      this.openAddEditList = true
    },
    handleDeleteList (item) {
      this.selectedList = item
      this.openDeleteListConfirmationDialog = true
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.inventoryList.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
    reset () {
      this.currentPage = 1
      this.fetchInventoryLists()
      this.closed()
    },
    closed () {
      this.selectedList = null
      this.openDeleteListConfirmationDialog = false
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    displayDate (value) {
      if (!value) {
        return null
      }
      const date = DateTime.fromISO(value)
      return date.toFormat('dd MMM yyyy')
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.empty-box {
  position: relative;
  border-radius: 10px;
  border: var(--v-basic500) dashed 2px;
}
::v-deep .v-slide-group__prev, .v-slide-group__next {
  flex: 0 1 16px !important;
  min-width: 16px !important;
}
::v-deep .v-tab {
  min-width: 24px !important;
}
.ellipsis-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>